module.exports = __webpack_public_path__ + "img/34069670000186.958ec323.png";